/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from 'react';
import {
  Button, DialogActions, DialogContent, Grid, Typography
} from '@material-ui/core';
import { translate } from 'utils';
import { RGPD_LINK } from 'utils/constants';
import { ModalHeader } from './_ModalHeader';

export const RGPDModal = ({
  onClose, onProceed
}) => {
  const handleProceed = useCallback(() => {
    onClose();
    onProceed();
  }, [onProceed]);

  return (
    <div >
    <ModalHeader className="rgpdModal" onClose={onClose}>
      {translate('subscription.rgpdTitle')}
    </ModalHeader>

  <DialogContent>
    <Grid
      container
      spacing={2}
      alignItems="center"
      wrap="wrap"  
    >
      <Grid
        item
        xs={12}     
        sm="auto"    
        style={{ textAlign: 'center' }}
      >
        <img
          alt="ConfirmationPaybox"
          src="/assets/images/rgpd.png"
          style={{
            maxWidth: '150px',
            width: '100%',
            height: 'auto',
            margin: '0 auto',
            display: 'block',
          }}
        />
      </Grid>

      <Grid
        item
        xs={12}     
        sm 
        style={{ height: '100%' }}
      >
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <Typography>
              {translate('subscription.rgpd1')}
            </Typography>
          </Grid>

          <Grid item>
            <Typography>
              {translate('subscription.rgpd2')}
              <a
                href={RGPD_LINK}
                rel="noopener noreferrer"
                target="_blank"
                style={{ marginLeft: '5px', wordBreak: 'break-word' }}
              >
                {RGPD_LINK}
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </DialogContent>

  <DialogActions>
    <Button
      style={{ color: 'var(--white)' }}
      onClick={onClose}
    >
      {translate('button.cancel')}
    </Button>
    <Button color="secondary" onClick={handleProceed}>
      {translate('subscription.understand&Accept')}
    </Button>
  </DialogActions>
</div>
  );
};